/* =============================================
   UNITY COFFEE — Custom variant UI enhancements
   ============================================= */

(function () {
  'use strict';

  const LABEL_SIZE_TEXT  = 'size';
  const LABEL_GRIND_TEXT = 'grind';

  function findContainerByLabelText(text) {
    const candidates = document.querySelectorAll('legend, .form__label, .product-form__label, label, h3, dt');
    for (const el of candidates) {
      if (el.textContent.trim().toLowerCase() === text) {
        return el.closest('fieldset') || el.closest('.product-form__option') || el.parentElement;
      }
    }
    return null;
  }

  // ─── 1. SIZE SAVINGS BADGES ────────────────

  function parseGrams(text) {
    text = (text || '').toLowerCase().replace(/\s/g, '');
    if (text.includes('2x250') || text.includes('2×250')) return 500;
    const match = text.match(/(\d+)g/);
    return match ? parseInt(match[1]) : null;
  }

  function initSavingsBadges() {
    const sizeContainer = findContainerByLabelText(LABEL_SIZE_TEXT);
    if (!sizeContainer) return;

    const variants = window.ShopifyAnalytics?.meta?.product?.variants;
    if (!variants) {
      console.info('[Unity] No variant data in ShopifyAnalytics');
      return;
    }

    // Парсим граммы и цены из v.name
    // Формат: "Brazil Nakamura – Espresso / 250g / Whole bean"
    const gramsPrice = {};
    for (const v of variants) {
      const parts = v.name.split('/');
      for (const part of parts) {
        const g = parseGrams(part.trim());
        if (g && (!gramsPrice[g] || v.price < gramsPrice[g])) {
          gramsPrice[g] = v.price;
        }
      }
    }

    if (!gramsPrice[250]) return;

    const basePPG = gramsPrice[250] / 250; // цена за грамм при 250g

    const sizeLabels = Array.from(sizeContainer.querySelectorAll('label'));
    for (const lbl of sizeLabels) {
      const g = parseGrams(lbl.textContent);
      if (!g || g === 250) continue;

      const p = gramsPrice[g];
      if (!p) continue;

      const pPG = p / g;
      const savePct = Math.round(((basePPG - pPG) / basePPG) * 100);
      if (savePct <= 0) continue;

      lbl.querySelector('.custom-size-savings-badge')?.remove();
      const badge = document.createElement('span');
      badge.className = 'custom-size-savings-badge';
      badge.textContent = `−${savePct}%`;
      lbl.appendChild(badge);
    }
  }

  // ─── 2. GRIND → SELECT DROPDOWN ────────────

  function initGrindDropdown() {
    const grindContainer = findContainerByLabelText(LABEL_GRIND_TEXT);
    if (!grindContainer) return;

    const inputs = Array.from(grindContainer.querySelectorAll('input[type="radio"]'));
    if (!inputs.length) return;

    if (grindContainer.querySelector('.custom-grind-select-wrapper')) return;

    const select = document.createElement('select');
    select.setAttribute('aria-label', 'Grind');

    for (const input of inputs) {
      const lbl = grindContainer.querySelector(`label[for="${input.id}"]`);
      const text = lbl ? lbl.textContent.trim() : input.value;
      const opt = document.createElement('option');
      opt.value = input.value;
      opt.textContent = text;
      if (input.checked) opt.selected = true;
      select.appendChild(opt);
    }

    // Скрываем оригинальные radio + их лейблы
    inputs.forEach(inp => {
      inp.style.cssText = 'position:absolute;opacity:0;pointer-events:none;width:1px;height:1px;';
      const lbl = grindContainer.querySelector(`label[for="${inp.id}"]`);
      if (lbl) lbl.style.display = 'none';
    });

    // Скрываем контейнер с кнопками
    const btnGroup = grindContainer.querySelector('ul, .swatch__list, .variant__buttons, .product-form__option-values');
    if (btnGroup) btnGroup.style.display = 'none';

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-grind-select-wrapper';
    wrapper.appendChild(select);
    grindContainer.appendChild(wrapper);

    select.addEventListener('change', () => {
      const target = Array.from(inputs).find(i => i.value === select.value);
      if (target) {
        target.checked = true;
        ['change', 'input', 'click'].forEach(evt =>
          target.dispatchEvent(new Event(evt, { bubbles: true }))
        );
      }
    });

    grindContainer.addEventListener('change', (e) => {
      if (e.target.type === 'radio' && e.target !== select) {
        select.value = e.target.value;
      }
    });
  }

  // ─── INIT ────────────────────────────────────

  function init() {
    initSavingsBadges();
    initGrindDropdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:product:update', init);

})();
(function() {
  var FREE_SHIPPING = 3500;

  function updateShippingBar(total) {
    var bar = document.querySelector('.free-shipping-bar__fill');
    var text = document.querySelector('.free-shipping-bar__text');
    if (!bar || !text) return;

    var remaining = FREE_SHIPPING - total;
    var progress = Math.min((total / FREE_SHIPPING) * 100, 100);

    bar.style.width = progress + '%';

    if (remaining > 0) {
      var euros = (remaining / 100).toFixed(2).replace('.', ',');
      text.innerHTML = 'Spend <strong>€' + euros + '</strong> more for free shipping!';
    } else {
      text.innerHTML = '🎉 You\'ve unlocked free shipping!';
    }
  }

  var subtotal = document.querySelector('[data-subtotal]');
  if (subtotal) {
    new MutationObserver(function() {
      var raw = subtotal.textContent.replace(/[^0-9,.]/g, '').replace(',', '.');
      var total = Math.round(parseFloat(raw) * 100);
      updateShippingBar(total);
    }).observe(subtotal, { childList: true, subtree: true, characterData: true });
  }
})();